/*-- import aliases -----------
'!/...' -> project root
'~/...' -> vue folder root
'@/...' -> src folder root
-----------------------------*/

// To make a new app, make a copy of this file, and the associated folder in the src directory - please leave this here as a template for new apps

import Vue from 'vue';
import Store from '@/filing-guidelines/store';
import App from '@/filing-guidelines/App.vue';

Vue.config.devtools = true;
Vue.config.productionTip = false;

window.addEventListener('DOMContentLoaded', () => {
	const elements = [...document.querySelectorAll('#filing-guidelines')];

	if (elements.length) {
		elements.forEach(el => {
			const app = new Vue({
				store: new Store().store,
				data: () => Object.assign({}, el.dataset),
				render: h => h(App)
			});
			app.$mount(el);
		});
	}
});
